var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%","margin-top":"-70px"}},[_c('Banner'),_vm._l((_vm.moduleList),function(item){return _c(item.cardType,{key:item.code,tag:"component",attrs:{"moduleData":item}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }